export function formatUserName(firstName, lastName) {
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- We want to include empty strings as well
  return firstName && lastName ? "".concat(firstName, " ").concat(lastName) : firstName || lastName || '';
}